import { observer, inject } from 'mobx-react';
import './index.less';
import { getAntd, getEcCom, getLabel } from '../../../util/convert';
import WfGroup from '../../../public/wf-group/index';
import WfCircleIcon from '../../../public/wf-circle-icon/index';
import { trim } from '../../../util/public/common';
import { reloadRequestPage } from '../../../util/formUtil';


/**
 * 明细导入
 */

@inject('globalStore', 'importFieldLinkageStore')
@observer
export default class Main extends React.Component { // /////
    constructor(props) {
        super(props);
        this.state = {
            filename: '',
            isShowDemoModal: false,
            fileid: '',
            importResultDialogVisible: false,
            submitBackData: { msg: '', totalData: 0, successData: 0, Parsing: true, failData: 0, dataSource: [] },
        };
    }

    componentDidMount() {
        const { importFieldLinkageStore } = this.props;
        const { workflowid } = this.props.globalStore.commonParam;
        importFieldLinkageStore.riggerFieldLinkageCfg({});
        importFieldLinkageStore.riggerFormulaCfg({ workflowid });
        importFieldLinkageStore.getExportFieldType({workflowid : workflowid});

    }

    cancelEvent = () => {
        const { controlDialogVisible } = this.props.globalStore;
        controlDialogVisible('importWfDetailModal', false);
        this.refs.group1.setShowGroup(true);
        this.refs.group2.setShowGroup(true);
        this.refs.group3.setShowGroup(true);
        $('.download-temp').find('input[name=excelfile]').val('');
    }

    render() {
        const { Modal, Row, Col, Button, message } = getAntd();
        const {WeaTools, WeaDialog,WeaCheckbox,WeaUpload, WeaSelect} = getEcCom();
        const warning = Modal.warning;
        const { globalStore, importFieldLinkageStore } = this.props;
        const { JSComplete, commonParam = {}, loading = false, dialogVisible } = globalStore;
        const { filename, isShowDemoModal, fileid } = this.state;
        const { workflowid, requestid, ismode, modeid, formid, isbill, nodeid, f_weaver_belongto_userid, f_weaver_belongto_usertype, wfTestStr, workflowname } = commonParam;
        let visible = false;
        let { SettingDialogVisible } = importFieldLinkageStore;
        if (dialogVisible.has('importWfDetailModal')) {
            visible = dialogVisible.get('importWfDetailModal');
        }
        const exportFieldOptions = [{
            key: '0',
            showname: getLabel('528205','仅导出可编辑列'),
            selected : importFieldLinkageStore.exportFieldType == '0'
        },{
            key: '1',
            showname: getLabel('528206','导出全部可见列'),
            selected : importFieldLinkageStore.exportFieldType == '1'
        }];

        const downloadTemplate = (<a
        onClick={this.downloadTemplate.bind(this, `${window.ecologyContentPath||''}/api/workflow/reqform/dowloadTemplate?requestid=${requestid}&workflowid=${workflowid}&nodeid=${nodeid}&modeid=${modeid}&_t=${new Date().getTime()}`)}
          target="_blank"
        >{`${workflowname}${getLabel(64, '模板')}`}</a>)

        const fieldTriggerCom = (
            <WeaCheckbox ecId={`${this && this.props && this.props.ecId || ''}_WeaCheckbox@6n82h9`}
              value={importFieldLinkageStore.isFieldTrigger}
              display="switch"
              onChange={(v) => {
            const para = {
                isFieldTrigger: v === '' ? importFieldLinkageStore.isFieldTrigger : v,
            };
            importFieldLinkageStore.updateIsFieldTrigger(para);
        }}
              helpfulTip={getLabel(512580, '明细导入时执行字段联动将直接修改数据库值')}
            />
    );
        const fieldFormulaCom = (
            <WeaCheckbox ecId={`${this && this.props && this.props.ecId || ''}_WeaCheckbox@191wfn`}
              value={importFieldLinkageStore.isFormula}
              display="switch"
              onChange={(v) => {
            const para = {
                isFormula: v === '' ? importFieldLinkageStore.isFormula : v,
                workflowid,
            };
            importFieldLinkageStore.updateIsFormula(para);
        }}
              helpfulTip={getLabel(514695, '启用后，触发动作为“值改变时”的明细表公式会在导入后执行，注意执行公式后需保存表单数据才会入库。')}
            />
    );
        const downloadTemp = (
            <div className="download-temp">
                <Row>
                    <Col span={10} style={{height: '28px', lineHeight: '28px'}}><WfCircleIcon/>{`${getLabel(530028,'模板导出列设置')}：`}</Col>
                    <Col span={14} style={{height: '28px', lineHeight: '28px'}} >
                        <WeaSelect
                            options={exportFieldOptions}
                            value={importFieldLinkageStore.exportFieldType}
                            detailtype={3}
                            viewAttr = {2}
                            onChange={(v,showname)=>{
                                importFieldLinkageStore.updateExportFieldType({workflowid : workflowid,exportFieldType : v });
                            }}
                        />
                    </Col>
                </Row>

            <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@0fuyyu`}>
    <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@ubscpl`} span={10} style={{height: '28px', lineHeight: '28px'}}><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@rggef0`} value='2'/>{`${getLabel(28576,'下载模板')}：`}
                        </Col>
                    <Col span={14}
                    style={{ height: '28px', lineHeight: '28px' }}
                    className="file-url"
                    ><div style={{width:'250px',float:'left' }}>
                       <div className="download-temp_name" title={workflowname}>{downloadTemplate}</div>
                    </div>
                       {
                            <div style={{
                                lineHeight: '28px',
                                height: '28px',
                                marginLeft: '15px',
                                display:"inlineBlock",
                                float:'left',
                            }}
                            >
                                <Button type="ghost"
                                 size="large"
                                 onClick={() => {
 this.importSetting(true); 
}}
                               >{getLabel(529991, '字段格式设置')}</Button>
                            </div>
                        }

                    </Col>
            </Row>
            <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@habu81`}>
    <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@t6y2cu`} span={10} style={{ height: '28px', lineHeight: '28px' }}><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@mdqutl`}
        value='3'/>{`${getLabel(16630,'上传Excel')}：`}</Col>
        <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@txo9np`} span={14}>

            <div style={{ width: '100%' }}>
                <WeaUpload
                  uploadUrl="/api/doc/upload/uploadFile"
                  category="string"
                  multiSelection={false}
                  maxFilesNumber={1}
                  limitType={'xls,xlsx'}
                  viewAttr={3}
                  maxUploadSize={5}
                  isDetail={true}
                  showClearAll={false}
                    requiredInfo={getLabel(522554,'未选择任何文件')}
                  prohibitType='rar'
                  onChange={(data, list, listT, listB) => {
                        // unde
                        console.log('list', list);
                        if (list.length > 0) {
                            this.setState({
                                fileid: list[0].fileid,
                            });
                        } else if (list.length == 0) {
                            this.setState({
                                fileid: '',
                            });
                        }
                        console.log('data', data);
                    }}
                  onUploading={status => console.log('主表 status: ', status)}
                  sortable={false}
                  showFilesize={false}
                  editable={false}
                />
            </div>
        </Col>
        </Row>
        <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@712rqa`}>
            <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@92lgq6`} span={10} style={{height: '28px', lineHeight: '28px'}}><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@gqvi2k`} value='4'/>{`${getLabel(512581,'导入时执行明细表字段联动')}：`}</Col>
            <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@gug8q1`} span={14} style={{height: '28px', lineHeight: '28px'}} className="file-url">{fieldTriggerCom}</Col>
        </Row>
        {ismode == 2 &&
        <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@be7cgx`}>
        <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@3zo4uy`} span={10} style={{height: '28px', lineHeight: '28px'}}><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@dq0gt1`} value='5'/>{`${getLabel(514693,'导入时执行明细表公式')}：`}</Col>
        <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@1haor3`} span={14} style={{height: '28px', lineHeight: '28px'}} className="file-url">{fieldFormulaCom}</Col>
            </Row>
        }
    </div>
    );

        const steps = (
            <div className="steps">
            <ul>
            <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@6ru2j6`} value="1" />
            {getLabel(27578, '请先下载')}
    <span className="template-download-url">{downloadTemplate}</span>
        {/*
						{'参照'}
						<span className="template-demo" onClick={this.openDemo.bind(this)}>
							<i className="icon-coms-content-o"/>
							{'填写范例'}
							<ImportDetailDemo visible={isShowDemoModal}/>
						</span> */
        }
        {getLabel(386198, '进行填写导入明细内容，第一行为表单明细字段的名称。')}
    </li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@g3icja`} value="2" />{getLabel(514843, '上传Excel”中选择填写好的Excel文件，并点击操作菜单中的“明细导入”按钮。')}</li>
        </ul>
        </div>
    );

        const precautions = (
            <div>
            <ul>
            <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@guekyh`} value="1" />{getLabel(27582, '导入明细数据时会将原有明细内容删除，导入新的模板中内容。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@mzg3ky`} value="2" />{getLabel(27583, '只有可编辑的字段才能进行导入，如果查看的字段有默认值的会自动加上默认值。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@o2uqeq`} value="3" />{getLabel(27584, '模板中第一行为表单明细字段名称，从第二行开始导入明细数据。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@vi95yh`} value="4" />{getLabel(27585, '明细数据之间不能有空行。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@sulll2`} value="5" />{getLabel(27586, '如果有多个明细时模板中会有多个SHEET，一个明细一个SHEET。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@81t46m`} value="6" />{getLabel(27587, '数字类型字段不要有特殊格式，例如：科学计数法，千分位，货币符号等。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@2tqlo2`} value="7" />{getLabel(515445, '浏览类型字段直接输入名称，也可同时输入名称+"##"+主键，例如：ID为20的人员“张三”，可输入“张三”、“##20”或“张三##20”。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@tyk1ck`} value="8" />{getLabel(27589, 'check类型字段输入“1/0”或“是/否”。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@ex20jd`} value="9" />{getLabel(514546, '下拉框、复选框、单选框类型字段直接输入选项显示名称。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@ru8v1q`} value="10" />{getLabel(514547, '多选浏览框或复选框填写多个值以英文半角逗号“,”分隔。')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@7iga95`} value="11" />{getLabel(531076, '人力资源字段支持编号导入，填写格式为：“workcode_具体编号”或者“名称workcode_具体编号”')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@eysqs3`} value="12" />{getLabel(531077, '部门字段支持编号导入，填写格式为：“deptcode_具体编号”或者“名称deptcode_具体编号”')}</li>
        <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@qq0ahx`} value="13" />{importFieldLinkageStore.tips13}</li>
            <li><WfCircleIcon ecId={`${this && this.props && this.props.ecId || ''}_WfCircleIcon@5qo2ml`} value="14" />{getLabel(515450, '支持行列规则(普通模式和HTML模式)、字段联动，不支持模板模式下的单元格公式计算，不支持属性联动。')}</li>
        </ul>
        </div>
    );

        return (
            <div>
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@vanu6k`}
              visible={visible}
              loadCss={true}
              initLoadCss={true}
              parentClassName="wea-import-wf-detail"
              style={{ width: '871px', height: '500px' }}
              hasScroll={true}
              maskClosable={false}
              onCancel={this.cancelEvent}
              icon={'icon-coms-workflow'}
              iconBgcolor={'#0079DE'}
              title={getLabel(26255, '明细导入')}
              buttons={[
            <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@ba8v57@dimport`}
              type="primary"
              size="large"
              disabled={loading || fileid == ''}
              onClick={this.submitEvent}
            >{getLabel(26255, '明细导入')}</Button>,
        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@rmuv9t@close`}
          type="ghost"
          size="large"
          disabled={loading}
          onClick={this.cancelEvent}
        >{getLabel(309, '关闭')}</Button>,
    ]}
            >
        <WfGroup ecId={`${this && this.props && this.props.ecId || ''}_WfGroup@yem50k`} ref={'group1'} title={getLabel(28576, '下载模板')} groupBodyComponent={downloadTemp} />
        <WfGroup ecId={`${this && this.props && this.props.ecId || ''}_WfGroup@8g8ead`} ref={'group2'} title={getLabel(27577, '操作步骤')} groupBodyComponent={steps} />
        <WfGroup ecId={`${this && this.props && this.props.ecId || ''}_WfGroup@sqzhcu`} ref={'group3'} title={getLabel(15736, '使用注意事项')} groupBodyComponent={precautions} />
        </WeaDialog>
                {/* 模板导出设置明细设置弹框 */}
                <WeaDialog visible={SettingDialogVisible}
                  loadCss={true}
                  initLoadCss={true}
                  parentClassName="wea-import-wf-detail"
                  style={{ width: '600px', height: '190px' }}
                  hasScroll={true}
                  maskClosable={false}
                  onCancel={() => {
 this.importSetting(false); 
}}
                  icon={'icon-coms-workflow'}
                  iconBgcolor={'#0079DE'}
                  title={getLabel(529991, '字段格式设置')}
                  buttons={[
                               <Button type="primary"
                                 size="large"
                                 onClick={() => {
 this.saveimportSetting(); 
}}
                               >{getLabel(86, '保存')}</Button>,
                               <Button type="ghost"
                                 size="large"
                                 onClick={() => {
 this.importSetting(false); 
}}
                               >{getLabel(309, '关闭')}</Button>,
                           ]}
                >
                        {
                            this.getSearchs()
                        }
                </WeaDialog>
                {/* 导入结果设置弹框 */}
                        {this.IMportDialog()}
        </div>
    );
    }
    IMportDialog=() => {
        const { globalStore, importFieldLinkageStore } = this.props;
        const { JSComplete, commonParam = {}, loading = false, dialogVisible } = globalStore;
        const { filename, isShowDemoModal } = this.state;
        const { WeaTable, WeaDialog } = getEcCom();
        const { Button } = getAntd();
        let successFlage;
        this.state.submitBackData.successData == 0 ? successFlage = false : successFlage = true;

          const columns = [{
            title: 'sheet',
            dataIndex: 'title',
            key: 'title',
            sorter: true,
            width: '18%',
          }, {
            title: getLabel(27592, '行'),
            dataIndex: 'row',
            key: 'row',
            sorter: true,
            width: '10%',
          }, {
            title: getLabel(18621, '列'),
            dataIndex: 'col',
            key: 'col',
            width: '10%',
          }, {
            title: getLabel(24960, '提示信息'),
            dataIndex: 'info',
            width: '52%',
            key: 'info',
            render: (text, record) => (
                    <sapn style={{ color: 'red', fontSize: '12px' }}>{text}</sapn>
                  ),
          }];
        return (
            <WeaDialog visible={this.state.importResultDialogVisible}
              loadCss={true}
              initLoadCss={true}
              parentClassName="wea-import-wf-detail"
              style={{ width: '700px', height: '400px' }}
              hasScroll={true}
              maskClosable={false}
              onCancel={this.importResultSure}
              icon={'icon-coms-workflow'}
              iconBgcolor={'#0079DE'}
              title={getLabel(82341, '导入结果')}
              buttons={[
                <Button type="primary" size="large" onClick={() => {
 this.importResultSure(); 
}}>{getLabel(826, '确定')}</Button>,
                // <Button type="ghost" size="large"  onClick={()=>{}}>{'更多'}</Button>,
            ]}
            >

         <div style={{ position: 'relative', top: '45%', transform: 'translateY(-50%)', padding: '0 20px' }}>

            <div style={{ textAlign: 'center', height: '100%', marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                {
                !successFlage ? <div style={{ color: '#FF0000', fontSize: '30px' }}><i className="icon-coms-Clear" /></div> :
                 <div style={{ color: '#54D3A4', fontSize: '30px' }}><i className="icon-coms02-icon-Completion" /></div>
                }
                 <div style={{ lineHeight: '40px', fontSize: '12px' }}>  &nbsp;&nbsp; {this.state.submitBackData.msg}</div>
             </div>

            <div>
            {this.state.submitBackData.msg2 && <div style={{ marginBottom: '10px' }}><span style={{ fontSize: '12px', color: '#FF0000' }}>{this.state.submitBackData.msg2}</span></div>}
            {(this.state.submitBackData.dataSource.length != 0) && <WeaTable columns={columns}
              dataSource={this.state.submitBackData.dataSource}
              childrenColumnName="subList"
              pagination={false}
              scroll={{ y: 150 }}
              needScroll={true}
            />
            }
            </div>
         </div>
 </WeaDialog>
        );
    }
    importSetting=(flage) => {
        const { importFieldLinkageStore, globalStore } = this.props;
        let { getDetailExpSetFn, changeSettingDialogVisibleFn } = importFieldLinkageStore;
        const { commonParam = {} } = globalStore;
        const { workflowid } = commonParam;
        changeSettingDialogVisibleFn(flage);// 弹框显影方法
        let parm = {
            workflowid,
        };
        flage == true && getDetailExpSetFn(parm);
    }
    getSearchs=() => {
        const { importFieldLinkageStore } = this.props;
        let { conditions, fixedForm } = importFieldLinkageStore;
        const { WeaSearchGroup, WeaFormItem, WeaSwitch } = getEcCom();
        let group = [];
        fixedForm && fixedForm.isFormInit && conditions.map((c) => {
            group.push(<WeaSearchGroup
              needTigger={true}
              title={c.title}
              showGroup={c.defaultshow}
              items={
                    c.items.map(field => ({
                    com: (
                      <WeaFormItem
                        label={field.label}
                        // labelCol={{ span: `${field.labelcol}` }}
                        // wrapperCol={{ span: `${field.fieldcol}` }}
                        labelCol={{ span: 9 ,offset:3}}
                        wrapperCol={{ span: 9  }}
                      >
                      <WeaSwitch fieldConfig={field} form={fixedForm} />
                    </WeaFormItem>
                    ),
                    col: 1,
                }))
            }
            />);
        },

          );
        return group;
      }
      saveimportSetting=() => {
        const { Modal, message } = getAntd();
        const { importFieldLinkageStore, globalStore } = this.props;
        let { fixedForm, saveDetailExpSetFn } = importFieldLinkageStore;
        const { commonParam = {} } = globalStore;
        const { requestid, f_weaver_belongto_userid, workflowid } = commonParam;
        let parm = fixedForm.getFormParams();
        parm.workflowid = workflowid;
        saveDetailExpSetFn(parm);// 调保存接口
    }
    importResultSure=() => {
        const { globalStore, importFieldLinkageStore } = this.props;
        const { commonParam = {}, controlDialogVisible } = globalStore;

        const { requestid,ismode } = commonParam;
            globalStore.setLoading(false);
            controlDialogVisible('importWfDetailModal', false);
            setTimeout(() => {
                if (importFieldLinkageStore.isFormula == '1' && ismode == 2) {
                    reloadRequestPage({ requestid, importDetail: '1' });
                } else {
                    reloadRequestPage({ requestid });
                }
            }, 500);
            this.setState({
                importResultDialogVisible: false,
            });
    }
    cancelEvent() {
        const { controlDialogVisible } = this.props.globalStore;
        controlDialogVisible('importWfDetailModal', false);
        this.refs.group1.setShowGroup(true);
        this.refs.group2.setShowGroup(true);
        this.refs.group3.setShowGroup(true);
        $('.download-temp').find('input[name=excelfile]').val('');
    }
    submitEvent = () => {
        const _this = this;
        const { Modal, message } = getAntd();
        const { fileid } = this.state;
        const { globalStore, importFieldLinkageStore } = this.props;
        const { WeaTools } = getEcCom();
        const { commonParam = {}, controlDialogVisible } = globalStore;
        const { workflowid, requestid, ismode, modeid, formid, isbill, nodeid, f_weaver_belongto_userid, f_weaver_belongto_usertype, wfTestStr } = commonParam;
        globalStore.setLoading(true);

        const params = {
            requestid,
            ismode,
            modeid,
            formid,
            isbill,
            nodeid,
            src: 'save',
            isfromE9: 1,
            f_weaver_belongto_userid,
            f_weaver_belongto_usertype,
            wfTestStr,
            isFieldTrigger: importFieldLinkageStore.isFieldTrigger,
            fileid,
        };

            WeaTools.callApi('/api/workflow/reqform/doImportDetail', 'POST', params).then((reVal) => {
                if (reVal.message != undefined && reVal.message != '' && JSON.parse(reVal.message).Parsing == true) {
                _this.setState({
                submitBackData: JSON.parse(reVal.message),
                importResultDialogVisible: true,
                });
                globalStore.setLoading(false);
                } else {
                globalStore.setLoading(false);
                Modal.warning({
                    title: getLabel(28535, '信息提示'),
                    content: reVal.msg || getLabel(528080, '解析模板失败'),
                  });
                }


            // if (!reVal.noRight) {
            //     const {message = ''} = reVal;
            //     Modal.warning({
            //         content: message.replace(/\\n/g, ''),
            //         okText: getLabel(826,'确定'),
            //         showClose: false,
            //         onOk() {
            //             controlDialogVisible('importWfDetailModal', false);
            //             setTimeout(function () {
            //                 if (importFieldLinkageStore.isFormula == "1" && ismode == 2) {
            //                     reloadRequestPage({requestid, "importDetail": "1"});
            //                 } else {
            //                     reloadRequestPage({requestid});
            //                 }
            //             },500)
            //         }
            //     });
            // } else {
            //     globalStore.setLoading(false);
            // }
        });
    }

    doFileChangeEvent = (e) => {
        const fileInfo = e.currentTarget.files[0];
        const { name = '', type = '' } = fileInfo;
        this.setState({ filename: name, type });
    }

    openDemo() {
        this.setState({ isShowDemoModal: true });
    }

    downloadTemplate(url) {
        jQuery('#WfFormFileDownload').attr('src', url);
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/dialog/import-wf-detail/index.js